// extracted by mini-css-extract-plugin
export default {"icon":"MinusButton-module__icon__FA5jr"};